import { render, staticRenderFns } from "./jh-member-info.vue?vue&type=template&id=21bd0063&scoped=true"
import script from "./jh-member-info.vue?vue&type=script&lang=js"
export * from "./jh-member-info.vue?vue&type=script&lang=js"
import style0 from "./jh-member-info.vue?vue&type=style&index=0&id=21bd0063&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bd0063",
  null
  
)

export default component.exports